class Price {
    constructor(manager) {
        this._init(manager)
    }
    _init(manager) {
        this.el = document.querySelector('[data-filter-price]') 
		this.manager = manager
        if(!this.el) {
            return
        }
        setTimeout(() => {
            this.findElements()
            this.setVariables()
            this.updateInputs(this.currMin, this.currMax)
            this.addListeners()
        }, 100)
    }
    findElements() {
        this.elMin       = this.el.querySelector('[data-filter-min]')
        this.elMax       = this.el.querySelector('[data-filter-max]')
        this.elLine      = this.el.querySelector('[data-filter-line]')
        this.elSquareMin = this.el.querySelector('[data-filter-price-action="min"]')
        this.elSquareMax = this.el.querySelector('[data-filter-price-action="max"]')
    }
    setVariables() {
        this.filterMin          = parseFloat(document.querySelector('[data-price-range-min]').getAttribute('data-price-range-min'))
        this.filterMax          = parseFloat(document.querySelector('[data-price-range-max]').getAttribute('data-price-range-max'))
        this.filterManager      = new FilterManager(this.el, this, this.manager)
        this.elSquareMin.square = new Square(this.elSquareMin, this)
        this.elSquareMax.square = new Square(this.elSquareMax, this)
        this.setVariablesFromURL()
    }
    setVariablesFromURL() {
        const mParams = new URLSearchParams(window.location.search)
        this.currMin  = mParams.get("from")
        this.currMax  = mParams.get("to")
        this.currMin = this.currMin ? this.currMin : this.filterMin
        this.currMax = this.currMax ? this.currMax : this.filterMax
        this.currMin = Math.min(this.currMin, parseInt(this.currMax) - parseInt(this.squareSizePerRange()))
        this.currMax = Math.max(this.currMax, parseInt(this.currMin) + parseInt(this.squareSizePerRange()))
    }      
    updateInputs(newMin, newMax) {
        // if(this.currMin == this.currMax && this.currMin >= this.filterMax - this.range()/2) {
        //     this.onChangeMax(newMax, false)
        //     this.onChangeMin(newMin, false)
        // } else {
            this.onChangeMin(newMin, false)
            this.onChangeMax(newMax, false)
        // }
    }
    addListeners() {
        this.elMin.addEventListener("input", () => this.onInputMin(this.clampMin(this.elMin.value)))
        this.elMax.addEventListener("input", () => this.onInputMax(this.clampMax(this.elMax.value)))
        this.elMin.addEventListener("change", () => this.onChangeMin(this.elMin.value))
        this.elMax.addEventListener("change", () => this.onChangeMax(this.elMax.value))
    }
    clampMin(value) {
        this.currMin = Math.min(Math.max(this.filterMin, value), this.currMax - this.squareSizePerRange())
        return this.currMin
    }
    onInputMin(newMin) {
        const percentage = (newMin - this.filterMin) / this.range() * 100
        this.updateVisuals("min", percentage)
    }
    onChangeMin(newMin, url = true) {
        const clamped = this.clampMin(newMin)
        this.elMin.value = clamped
        this.onInputMin(clamped)
        // this.elMin.blur()
        if(url) {
            this.filterManager.changeURL(clamped, this.currMax)
        }
    }
    clampMax(value) {
        this.currMax = Math.min(Math.max(this.currMin + this.squareSizePerRange(), value), this.filterMax)
        return this.currMax
    }
    onInputMax(newMax) {
        const percentage = (newMax - this.filterMin)  / this.range() * 100
        this.updateVisuals("max", percentage)
    }
    onChangeMax(newMax, url = true) {
        const clamped = this.clampMax(newMax)
        this.elMax.value = clamped
        this.onInputMax(clamped)
        // this.elMax.blur()
        if(url) {
            this.filterManager.changeURL(this.currMin, clamped)
        }
    }
    updateVisuals(s, newVal) {
        newVal = Math.min(Math.max(0, newVal), 100)
        if(s === "min") {
            this.elSquareMin.style.left = newVal + "%"
        } else {
            this.elSquareMax.style.right = (this.range() != 0 ? 100 - newVal : 0) + "%"
        }
        this.setOnTop(s)
        this.updateLine()
    }
    updateLine() {
        if(this.range() == 0) {
            this.elLine.style.transform = "translate(0) scale(1, 1)"            
            return
        }
        const min = this.elSquareMin.style.left
        const width = (this.currMax - this.currMin) / this.range()
        this.elLine.style.transform = "translate(" + min +") scale(" + width + ", 1)"
    }
    setOnTop(square) {
        if(square === "min") {
            this.elSquareMin.style.zIndex = "1"            
            this.elSquareMax.style.zIndex = "0"
        } else {
            this.elSquareMin.style.zIndex = "0"
            this.elSquareMax.style.zIndex = "1"
        }
    }
    range() {
        return this.filterMax - this.filterMin
    }
    squareSizePerCent() {
        return this.elSquareMin.square.sizePerCent()
    }
    squareSizePerRange() {
        return Math.ceil(this.squareSizePerCent() * this.range())
    }
}

class FilterManager {
    constructor(el, price, manager) {
        this._init(el, price, manager)
    }
    _init(el, price, manager) {
        this.el = el
        this.manager = manager
        this.minKey = "from"
        this.maxKey = "to"
        this.price = price
    }
    updateFromManager() {
        if(!this.el) {
            return
        }
        const mParams = this.manager.params
        const paramMin = mParams.get(this.minKey)
        const paramMax = mParams.get(this.maxKey)
        const newMin = paramMin ? paramMin : this.price.filterMin
        const newMax = paramMax ? paramMax : this.price.filterMax
        this.price.updateInputs(newMin, newMax)
    }
    changeURL(min, max) {
        const mParams = this.manager.params
        if(min !== null) {
            mParams.set(this.minKey, min)
        }
        if(max !== null) {
            mParams.set(this.maxKey, max)
        }
        
        this.manager.updateParams(mParams, true)
    }
}

class Square {
    constructor(el, manager) {
        this._init(el, manager)
    }
    _init(el, manager) {
        this.el = el
        this.manager = manager
        if(!this.el) {
            return
        }
        this.elRectangle = document.querySelector('[data-filter-price-rectangle]')
        this.action = this.el.getAttribute('data-filter-price-action')
        
        this.usePointer = this.isEventSupported()

        if(this.usePointer) {
            this.el.addEventListener("pointerdown", (e) => this.onMouseDown(e))
        } else {
            this.el.addEventListener("mousedown", (e) => this.onMouseDown(e))
        }
    }
    isDesktop() {
		return window.matchMedia("only screen and (min-width: 1024px)").matches        
    }
    onMouseDown(event) {
        event.preventDefault()
        this.setNewValue(event)
        if(this.usePointer) {
            window.onpointerup   = (e) => this.onMouseUp(e)
            window.onpointermove = (e) => this.setNewValue(e)
        } else {
            window.onmouseup   = (e) => this.onMouseUp(e)
            window.onmousemove = (e) => this.setNewValue(e)
        }
    }
    onMouseUp(e) {
        this.setNewValue(e, true)
        if(this.usePointer) {
            window.onpointerup   = null
            window.onpointermove = null
        } else {
            window.onmouseup   = null
            window.onmousemove = null
        }
    }
    setNewValue(e, changeUrl = false) {
        const newInput = this.getNewValue(e)
        if(this.action==="min") {
            this.manager.onChangeMin(newInput, changeUrl)
        }
        else {
            this.manager.onChangeMax(newInput, changeUrl)
        }
    }
    getNewValue(e) {
        const mouseRelativeX = e.clientX - this.elRectangle.getBoundingClientRect().left
        const percentage = this.clamp(mouseRelativeX) / this.parentWidth()
        return Math.round(percentage * this.manager.range() + this.manager.filterMin)
    }
    parentWidth() {
        // return parseInt(window.getComputedStyle(this.elRectangle).getPropertyValue('width'))
        return this.elRectangle.offsetWidth
    }
    clamp(toClamp){
        return Math.min(Math.max(0, toClamp), this.parentWidth())
    }
    isEventSupported(eventName = 'pointerdown') {
        var el = document.createElement('div')
        eventName = 'on' + eventName
        var isSupported = (eventName in el)
        if (!isSupported) {
        el.setAttribute(eventName, 'return')
        isSupported = typeof el[eventName] == 'function'
        }
        el = null
        return isSupported
    }
    size() {
        // return parseInt(window.getComputedStyle(this.el).getPropertyValue('width')) + 2
        return this.el.offsetWidth + 2
    }
    sizePerCent() {
        return this.size() / this.parentWidth()
    }
}

export default Price